var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSquareDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.6667 0.875H1.33333C0.979711 0.875 0.640573 1.01548 0.390524 1.26552C0.140476 1.51557 0 1.85471 0 2.20833V15.5417C0 15.8953 0.140476 16.2344 0.390524 16.4845C0.640573 16.7345 0.979711 16.875 1.33333 16.875H14.6667C15.0203 16.875 15.3594 16.7345 15.6095 16.4845C15.8595 16.2344 16 15.8953 16 15.5417V2.20833C16 1.85471 15.8595 1.51557 15.6095 1.26552C15.3594 1.01548 15.0203 0.875 14.6667 0.875ZM14.6667 15.5417H1.33333V2.20833H14.6667V15.5417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquareDraw);
export default __webpack_public_path__ + "static/media/icon-square-draw.14a8f305b396f4a835e1356814f1f8bc.svg";
export { ForwardRef as ReactComponent };